import { render } from "./TexteditorComponent.vue?vue&type=template&id=f3b817ea"
import script from "./TexteditorComponent.vue?vue&type=script&lang=js"
export * from "./TexteditorComponent.vue?vue&type=script&lang=js"

import "./TexteditorComponent.vue?vue&type=style&index=0&id=f3b817ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__